<template
  ><!--会员卡片 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img class="pointer" @click="clickLocalStep()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">会员卡片</span>
    </div>
    <!--  活动条件表单部分 -->
    <div v-loading="fromLoading" class="secondstep">
      <el-form :disabled="backgroundOpacity" :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="160px">
        <div class="newsInfo" style="margin-top:0px;">基本信息</div>
        <el-form-item label="计划名称:" required>
          <el-input v-model="ruleForm.activityName" maxlength="15" show-word-limit placeholder="请输入" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="计划时间:" required>
          <div class="my_select_time">
            <el-date-picker
              v-model="activityTimeValue"
              type="datetimerange"
              class="rangeTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              ref="timeBox"
              @change="activityTimeChange"
              style="width: 400px; font-size: 12px"
              :picker-options="pickerOptionsValue"
              :default-time="defaultTime"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
          </div>
          <span class="lastTime" style="color: #666">
            活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天 <span style="color: #7B61FF">{{ timeOut }}</span> 小时
            <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>
        <div class="newsInfo">卡片设置</div>
        <el-form-item label="选择模板:" required>
          <div>
            <!-- <el-button slot="reference" @click="giftPopup = true" type="text" style="width:95px;background: #7B61FF;color:#fff;">选择模板</el-button> -->
          </div>
           <el-radio v-model="templateType" :label="0" > 系统模板</el-radio>
           <selectTemplatePart :activityDataID="32" @handleChoice="handleSelectTemplate"
              :selectedTemplateId="ruleForm.ruleDTO.templateId"
            />
          <!-- 预览效果 -->
          <div class="smart">
            <div class="smart_left" >
              <div class="smart_content">
                <img :src="ruleForm.winImageUrl" alt="" />
                <div class="MesgTips" :style="{color: `rgb(${activityValue.rgb2})`}">
                  <div>亲爱的***，您好</div>
                  <div>我们已陪伴您423天！</div>
                </div>
                <div class="smart_icons">
                  <div v-for="item in ruleForm.ruleDTO.benefitList" v-if="item.icon">
                    <div class="icons_img"><img :src="item.icon" alt=""></div>
                    <div class="icons_text" :style="{color: `rgb(${activityValue.rgb2})`}">{{ item.text||"" }}</div>
                  </div>
                </div>
                <div class="text" :style="{color: activityValue.rgb}">{{ ruleForm.ruleDTO.notOpenText }}</div>
              </div>
            </div>
            <div class="smart_right">
              <div class="smart_content">
                <img :src="ruleForm.noWinImageUrl" alt="" />
                <div class="text" :style="{color: activityValue.rgb}">{{ ruleForm.ruleDTO.openCardText }}</div>
                <div class="MesgTips" :style="{color: `rgb(${activityValue.rgb2})`}">
                  <div>亲爱的***，您好</div>
                  <div>我们已陪伴您423天！</div>
                </div>
                <div class="level_line">
                  <div class="level_line_s" :style="{backgroundColor: `rgba(${activityValue.rgb2},0.2)`}"></div>
                  <!-- 等级进度 -->
                  <div class="level_process" :style="{width: '75px', backgroundColor: `rgb(${activityValue.rgb2})` }"></div>
                </div>
                <div class="level_name" >
                  <div class="level_name_item level_name_active" :style="{color: `rgb(${activityValue.rgb2})`,marginLeft:'10px'}">普通会员
                    <div class="level_name_actives" :style="{border: `3rpx solid rgb(${activityValue.rgb2})`}"></div>
                  </div>
                  <div class="level_name_item level_name_active" :style="{color: `rgb(${activityValue.rgb2})`,marginLeft:'40px'}">中级会员
                    <div class="level_name_items" :style="{border: `3rpx solid rgb(${activityValue.rgb2})`}"></div>
                  </div>
                  <div class="level_name_item level_name_active" :style="{color: `rgb(${activityValue.rgb2})`,marginLeft:'40px'}">高级会员
                    <div class="level_name_items" :style="{border: `3rpx solid rgb(${activityValue.rgb2})`}"></div>
                  </div>
                  <div class="level_name_item level_name_active" :style="{color: `rgb(${activityValue.rgb2})`,marginLeft:'40px'}">至尊会员
                    <div class="level_name_items" :style="{border: `3rpx solid rgb(${activityValue.rgb2})`}"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="smart_right_tip">图为预览效果，以实际投放位置效果为准</div>
        </el-form-item>
        <el-form-item label="未入会文案:" required>
          <el-input v-model="ruleForm.ruleDTO.notOpenText" maxlength="12" show-word-limit placeholder="请填入未入会文案" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="已入会文案:" required>
          <el-input v-model="ruleForm.ruleDTO.openCardText" maxlength="12" show-word-limit placeholder="请填入已入会文案" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="权益信息:" required>
            <div>
                <div style="display:flex;">
                    <div class="qyLeft" style="background:#f8f9ff;">权益icon</div>
                    <div class="qyRight" style="background:#f8f9ff;">权益名称</div>
                </div>
                <div style="display:flex" v-for="(item,index) in ruleForm.ruleDTO.benefitList" class="qyBox">
                    <div class="qyLeft">
                        <img :src="item.icon" alt="" v-if="item.icon" style="width:40px;height:40px;margin-top: 5px;margin-left:10px;cursor: pointer;" @click="openLeft(index)">
                        <el-button @click="openLeft(index)" type="text" v-else style="text-align:left;">选择</el-button>
                    </div>
                    <div class="qyRight">
                        <el-input v-model="item.text" maxlength="4" show-word-limit></el-input>
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item label="未入会领取跳转链接:" required>
          <el-input disabled v-model="ruleForm.ruleDTO.notOpenUrl" placeholder="请输入" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="已入会领取跳转链接:" required>
          <el-input v-model="ruleForm.ruleDTO.openCardUrl" placeholder="请输入" style="width: 400px"></el-input>
        </el-form-item>
        <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
      </el-form>
    </div>
    <div class="create_bottom">
      <el-button class="returnBtn" size="medium" @click="clickLocalStep()"> {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button>
      <template v-if="!backgroundOpacity">
        <!-- <el-button class="keepBtn" type="primary" size="medium" @click="joinBlackList = true" v-preventReClick>保存并完成设置</el-button> -->
        <el-button class="saveBtn" type="primary" size="medium" @click="joinBlackList = true" v-preventReClick>保存并完成设置</el-button>
        <!-- <el-popover
          placement="top-start"
          width="300"
          trigger="hover"
          content="因官方改造，小部件功能下架，如需实现类似功能可联系客服了解店铺装修定制业务~">
          <el-button class="keepBtn" type="primary" slot="reference">保存并完成设置</el-button>
        </el-popover> -->
      </template>
    </div>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProductAward"
      :Sans="venderType"
      :echoDate="echoDate"
      :actId="{ id: valueRow }"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 确定礼包模板弹窗 -->
    <gift-popup :activityDataID="32" @handleChoice="handleChoice" v-if="giftPopup" />
    <image-manage :dialoguploadVisible="dialoguploadVisible" @on-close="dialoguploadVisible = false" @on-confirm="onConfirm"></image-manage>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import selectProduct from "../select_product";
import { mapState } from "vuex";
import { saveScratchers, editScratchers, memberCardSave,memberCardList } from "@/api/paradiseAndTaskCommonController.js";
import imageManage from "@/views/integralCenter/image_manage2";
import giftPopup from "./giftPopup.vue";
import selectTemplatePart from "@/views/integralCenter/cardManage/selectTemplatePart.vue";

export default {
  components: {
    selectProduct,
    imageManage,
    giftPopup,
    selectTemplatePart,
  },
  computed: {
    ...mapState(["venderType"]),
    winningRate() {
      let winningRate = 0;
      this.awardSettingsLsit.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });
      return winningRate;
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      }
      return result;
    },
    toChinesNum(num) {
      let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) + newNum;
        }
        if (num >= 10 && num < 20) {
          newNum = newNum.substring(1, 3);
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },

  data() {
    return {
        dialogOpenIndex: '',
        dialoguploadVisible: false,
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      templateType:0,
      giftPopup: false,
      stepNum: 0,
      backgroundOpacity: false,
      isSave: true,
      valueRow: null,
      //
      echoDate: {},
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      qrcode: null,
      joinBlackList: false,
      checked: false,
      activityStartTime: null,
      activityEndTime: null,
      timeDay: 0,
      timeOut: 0,
      ruleForm: {
        //设置规则表单
        activityName: "",
        ruleDTO: {
            notOpenUrl: '',
            openCardUrl: '',
            notOpenText: '专享福利 好礼等你来领',
            openCardText: '专享福利 好礼等你来领',
            templateId: '',
            benefitList: [
                {
                    icon: '',
                    text: '',
                },
                {
                    icon: '',
                    text: '',
                },
                {
                    icon: '',
                    text: '',
                },
                {
                    icon: '',
                    text: '',
                },
                {
                    icon: '',
                    text: '',
                },
            ]
        }

      },
      awardSettingsLsit: [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
        },
      ],
      awardIndex: 0,
      timeState1: "",
      staute: 0,
      activityValue: {},
    };
  },
  created() {
    // 数据初始化
    if (this.$route.query.valueRow) {
      this.backgroundOpacity = this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment = this.$route.query.statusComment == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.getEdit();
    } else {
      this.activityTimeChange();
    }
    // this.activityTimeChange();
  },
  mounted() {
    let venderId = this.$store.getters.loginUserInfo.venderId;
    this.ruleForm.ruleDTO.notOpenUrl = `https://shopmember.m.jd.com/shopcard/?venderId=${venderId}&venderType=1&channel=80140887`
  },
  methods: {
    openLeft(index) {
        this.dialogOpenIndex = index
        this.dialoguploadVisible = true
    },
    onConfirm(item) {
        this.ruleForm.ruleDTO.benefitList[this.dialogOpenIndex].icon = item.imageUrl
        console.log(item,111)
      this.dialoguploadVisible = false;
    //   this.createform.imageUrl = item.imageUrl;
    //   if (item.id) {
    //     this.createform.templateId = item.id;
    //   } else {
    //     this.createform.templateId = null;
    //   }
    },
    async getEdit() {
      const { data } = await memberCardList(this.valueRow);
      console.log(data,'编辑');
      this.staute = data.status || 0;
      this.timeState1 = data.startTime;
      this.activityTimeValue = [String(data.startTime), String(data.endTime)];
      this.ruleForm.activityName = data.activityName;
      this.ruleForm.activityStartTime = String(data.startTime);
      this.ruleForm.activityEndTime = String(data.endTime);
      this.ruleForm.ruleDTO = data.ruleDTO
      this.ruleForm.id = data.id
      this.ruleForm.noWinImageUrl = data.ruleDTO.secondPictureUrl;
      this.ruleForm.winImageUrl = data.ruleDTO.firstPictureUrl;
      this.activityValue.rgb = data.ruleDTO.themeColor
      this.activityValue.rgb2 = data.ruleDTO.memberInfoColor
      if(this.$route.query.isCopy == "1"){
        this.valueRow = ""
        this.ruleForm.id = ""
      }
      this.activityTimeChange();
    },
    handleChoice(val) {
      console.log(val);
      if (val) {
        // this.ruleForm.gameTemplateId = val.id;
        this.ruleForm.ruleDTO.templateId = val.id;
        this.ruleForm.winImageUrl = val.imageUrl;
        this.ruleForm.noWinImageUrl = val.secondImageUrl;
        this.ruleForm.thankImageUrl = val.thankImageUrl;
        this.activityValue = val
      }
      this.giftPopup = false;
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime && this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime && this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // if (days > 90) {
        //   this.$message.warning("活动时间不得超过90天！");
        //   this.ruleForm.activityEndTime = null;
        //   this.timeOut = 0;
        //   this.timeDay = 0;
        //   return;
        // }

        this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.valueRow) {
          this.disableTime = true;
        } else {
          // console.log(this.activityTimeValue);
          // this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          // this.activityTimeValue[0] = "";
          // this.ruleForm.activityStartTime = null;
          // return;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");

        return;
      }
    },
    deletePacket(index) {
      this.awardSettingsLsit.splice(index, 1);
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, 666);
      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal = data.quantityTotal;
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(data.giftType);
      }
      if(prizeType == 3) {
        if(!data.isGoodManage) {
          delete this.awardSettingsLsit[this.awardIndex].isGoodManage
        } else {
          this.awardSettingsLsit[this.awardIndex].isGoodManage = data.isGoodManage;
        }
      }
      this.awardSettingsLsit[this.awardIndex].price = data.discount || data.singleAmount;

      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title = data.discount + "店铺积分";
      } else {
        this.awardSettingsLsit[this.awardIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount = data.singleAmount;
      }
      console.log(this.awardSettingsLsit, 123);
    },
    addPacket() {
      this.awardSettingsLsit.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
      });
    },
    // 红包雨
    selectPacket(index, item) {
      this.$refs.selectProductAward.openDialog();
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.echoDate = item;
    },
    // 保留小数点后两位
    oninput2(obj) {
      obj = obj.replace(/[^\d.]/g, ""); //清除除了“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3"); //只能输入3个小数
      if (obj > 100) {
        obj = 100;
      }

      let value = obj * 1;
      let winningRate = 0;
      this.awardSettingsLsit.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        obj = 100 - (winningRate - value);
      } else if (winningRate == 100) {
        if (value >= 100) {
          obj = 100;
        } else {
          obj = 100 - (winningRate - value);
          if (value == 0) {
            obj = 0;
          }
        }
      }
      return obj;
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        row.prizeCount = row.totalAmount;
        if (row.quantityTotal && row.price && row.totalAmount && row.prizeType == 2) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    // 抽奖判断
    orderChange() {
      if (
        Number(this.ruleForm.oneDayMaxDrawNumber) > Number(this.ruleForm.totalMaxDrawNumber) &&
        this.ruleForm.totalMaxDrawNumber &&
        this.ruleForm.oneDayMaxDrawNumber
      ) {
        this.ruleForm.totalMaxDrawNumber = "";
        this.$message.warning("活动期间每人每天抽奖次数不能大于累计抽奖次数");
      }
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) > Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.oneDayMaxRewardNumber &&
        this.ruleForm.totalMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      try{
        this.ruleForm.activityStartTime = this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[0];
        this.ruleForm.activityEndTime = this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[1];
      }catch(err){
        this.$message.warning("请输入计划时间");
        return;
      }

      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        gameTemplateId: this.ruleForm.gameTemplateId,
        ruleDTO: {
          oneDayMaxDrawNumber: this.ruleForm.oneDayMaxDrawNumber,
          totalMaxDrawNumber: this.ruleForm.totalMaxDrawNumber,
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber,
          extraUrl: this.ruleForm.extraUrl,
          noWinImageUrl: this.ruleForm.noWinImageUrl,
          winImageUrl: this.ruleForm.winImageUrl,
          thankImageUrl: this.ruleForm.thankImageUrl,
        }, //活动名称
        integralParadisePrizeDTOS: [], // 奖品
      };
      let isflay = false;
      cardParams.integralParadisePrizeDTOS = this.awardSettingsLsit.map((item) => {
        let prize = {
          ...item,
          title: item.title,
          assetsId: item.assetsId,
          prizeType: item.prizeType,
          singleAmount: item.singleAmount, //
          totalAmount: item.totalAmount, // 总数额
          price: item.price,
          percentage: item.percentage ? item.percentage * 1 : 0,
        };
        if (prize.prizeType == 3||prize.prizeType == 10) {
          prize.logo = item.logo;
        }
        if (prize.prizeType == 1) {
          prize.quota = item.quota;
          prize.couponType = item.couponType;
        }
        if (prize.prizeType == 2 || prize.prizeType == 4) {
          prize.singleAmount = item.price;
        } else {
          prize.singleAmount = 1;
        }
        if (!item.singleAmount) isflay = true;
        return prize;
      });

      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入计划名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入计划时间");
        return;
      }
      let nowTime = new Date().getTime()
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      if(end < nowTime && end){
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (!this.ruleForm.winImageUrl) {
        this.$message.warning("请选择模板");
        return;
      }
      if (!this.ruleForm.ruleDTO.notOpenText) {
        this.$message.warning("请输入未入会文案");
        return;
      }
      if (!this.ruleForm.ruleDTO.openCardText) {
        this.$message.warning("请输入已入会文案");
        return;
      }
      let isQY = false
      this.ruleForm.ruleDTO.benefitList.forEach(e=>{
        if(!e.icon || !e.text) {
          isQY = true
        }
      })
      if(isQY) {
        this.$message.warning("请完整输入权益信息");
        return;
      }

      if (!this.ruleForm.ruleDTO.notOpenUrl) {
        this.$message.warning("请输入未入会领取跳转链接");
        return;
      }
      if (!this.ruleForm.ruleDTO.openCardUrl) {
        this.$message.warning("请输入已入会领取跳转链接");
        return;
      }




      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        console.log(this.ruleForm)
        let obj = JSON.parse(JSON.stringify(this.ruleForm)) 
        obj.endTime = obj.activityEndTime
        obj.startTime = obj.activityStartTime
        memberCardSave(obj).then(res=>{
          if(res.code == 1) {
            this.joinBlackList = false;
            this.clickLocalStep()
          }else{
            this.$message.warning(res.message);
          }

        })
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        text10 = "",
        text11 = "",
        text12 = "",
        text13 = "",
        text14 = "",
        text15 = "",
        text16 = "",
        text17 = "",
        text18 = "",
        text19 = "",
        text20 = "";
      //活动名称
      // if (this.ruleForm.activityName.length > 0) {
      //   text1 = "活动名称：" + this.ruleForm.activityName;
      // }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 = "1、计划时间：" + this.ruleForm.activityStartTime + "至" + this.ruleForm.activityEndTime + "；";
      }
      text2 = `2、抽奖和中奖规则：活动期间每人每天抽奖不超过${this.ruleForm.oneDayMaxDrawNumber || "--"}次，累计抽奖不超过${this.ruleForm
        .totalMaxDrawNumber || "--"}次,活动期间每人每天中奖不超过${this.ruleForm.oneDayMaxRewardNumber || "--"}次，累计中奖不超过${this.ruleForm
        .totalMaxRewardNumber || "--"}次；`;
      text3 = "3、奖品数量有限，先到先得";
      text4 = "4、若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；";
      text5 = "注：奖品发放形式： 实物奖：";
      text6 = "  中奖客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放)";
      text7 =
        "  实物奖采取寄送方式发放，获奖用户需在开奖后填写姓名、联系电话、详细地址信息。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品；";
      text8 = "虚拟产品奖：";
      text9 = "  （1）京豆、红包、积分、京东E卡：中奖后系统预计24小时内自动发放至账户；";
      text10 = "  （2）发放型优惠券：中奖后自动发放，预计24小时到账；";
      text11 = "  （3）领取型优惠券：中奖后需手动领取，预计24小时到；";
      text12 = "  （4）PLUS会员、爱奇艺会员卡：中奖后需手动兑换；";
      text13 = "活动参与主体资格：";
      text14 =
        "  （1）每位自然人用户仅能使用一个京东账号参与活动，微信号、QQ、京东帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效。";
      text15 = "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。";
      text16 = "注意事项：";
      text17 =
        "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利。";
      text18 =
        "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。";
      text19 = "  （3）本活动所发放的实物奖不得提现、不得转赠他人、不得为他人付款。";
      text20 = "  （4）是否中奖以活动发布者后台统计结果为准。";
      let Arr1 = [
        text1,
        text2,
        text3,
        text4,
        text5,
        text6,
        text7,
        text8,
        text9,
        text10,
        text11,
        text12,
        text13,
        text14,
        text15,
        text16,
        text17,
        text18,
        text19,
        text20,
      ];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    clickLocalStep() {
      this.$router.go(-1);
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    handleSelectTemplate(val) {
      console.log("--- ~ val:---", val)
      if (val) {
        // this.ruleForm.gameTemplateId = val.id;
        this.ruleForm.ruleDTO.templateId = val.id;
        this.ruleForm.winImageUrl = val.imageUrl;
        this.ruleForm.noWinImageUrl = val.secondImageUrl;
        this.ruleForm.thankImageUrl = val.thankImageUrl;
        this.activityValue = val
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.MesgTips{
  position: absolute;
  top: 17px;
  left: 25px;
  >div:nth-of-type(1){
    font-size: 20px;
    font-weight: bold;
    line-height: 15px;
  }
  >div:nth-of-type(2){
    font-size: 15px;
  }
}
.level_line {
  width: 370px;
  height: 40px;
  position: absolute;
  top: 71px;
  left: 30px;
}

.level_line_s {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  width: 100%;
  background-color: rgba(113, 39, 6, 0.2);
  z-index: 1;
}
.level_process {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  content: "";
  height: 4px;
  background-color: rgb(113, 39, 6);
  z-index: 2;
}
.level_name {
  display: flex;
  justify-content: space-between;
  color: rgba(113, 39, 6, 0.4);
  font-size: 14px;
  margin-top: 6px;
  position: absolute;
  top: 95px;
  left: 30px;
}

.level_name_item {
  position: relative;
}

.level_name_items {
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 3px solid #712706;
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 3;
}

.level_name_active {
  color: #712706;
}

.level_name_actives {
  position: absolute;
  top: -21px;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 22px;
  background-color: #fff;
  border: 5px solid #712706;
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 4;
}
.smart {
  display: flex;
  position: absolute;
  top: -170px;
  left: 350px;
  // margin-top: 24px;
  // width: 100%;
  // height: 10px;
  // margin-left: -240px;
  // margin-bottom: 420px;
  transform: scale(0.5,0.5);
  &_left {
    width: 470px;
    height: 860px;
    background: url("../../../assets/thdImg/active/hykq3.png") no-repeat;
    background-size: 470px 860px !important;
    margin-right: 30px;
    display: flex;
    justify-content: center;
  }
  &_content {
    width: 93%;
    // background: #7B61FF;
    height: 90px;
    margin-top: 360px;
    position: relative;
    img {
      width: 100%;
      height: 225px;
    }
    .smart_icons{
      width: 390px;
      height: 70px;
      // background-color: #7b61ffaf;
      position: absolute;
      left: 24px;
      bottom: -43px;
      display: flex;
      justify-content: flex-start;
      >div{
        width: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
      }
      .icons_img{
        margin-top: 10px;
        img{
          width: 45px;
          height: 45px;
        }
      }
      .icons_text{
        margin-top: -14px;
        color: #ffffff;
      }
    }
    .text{
      width: 200px;
      height: 15px;
      position: absolute;
      left: 17px;
      bottom: -83px;
      color: #ffffff;
      font-size: 16PX;
    }
  }
  &_right {
    width: 470px;
    height: 860px;
    background-size: 470px 860px !important;
    background: url("../../../assets/thdImg/active/hykq3.png") no-repeat;
    display: flex;
    justify-content: center;
    // &_img {
    //   height: 430px;
    //   background: #999;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
  }
}
.smart_right_tip {
  width: 500px;
  color: #999;
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
  position: absolute;
  left: 584px;
  top: 480px;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.card-point {
  width: 100%;
  background: #fafafa;
  border-radius: 4px;
  margin-top: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    // margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
    line-height: 1;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.add_btn1 {
  cursor: pointer;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.memberTips {
  color: red;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
}

.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}

.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7b61ff;
  }
  color: #999;
}
.delectPosible {
  position: absolute;
  top: -3px;
  right: 6px;
  color: red;
  cursor: pointer;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}

.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 40px 28px 1px 24px;
    // margin-bottom: 29px;
    height: calc(100vh - 225px);
    overflow-y: auto;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url("../../../assets/images/integralCenter/yhq.png");
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #7b61ff;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
  }
}
.keepBtn {
    margin-left: 30px;
    width: 188px;
    background: #f2f3f5;
    border-color: #f2f3f5;
    color: #cccccc;
    transition: all 0.2s;
    .el-button--primary{
      background: #f2f3f5;
      border-color: #f2f3f5;
      color: #cccccc;
    }
    &:hover {
      opacity: 0.9;
    }
  }

.saveBtn {
    margin-left: 30px;
    width: 188px;
    transition: all 0.2s;
    .el-button--primary{
      background: #f2f3f5;
      border-color: #f2f3f5;
      color: #cccccc;
    }
    &:hover {
      opacity: 0.9;
    }
  }
.qyBox:last-child .qyLeft,
.qyBox:last-child .qyRight
{
    border-bottom: 1px solid #EEEEEE;
}
.qyLeft{
    width: 150px;
    border-top: 1px solid #EEEEEE;
    border-left: 1px solid #EEEEEE;
    border-right: 1px solid #EEEEEE;
    padding-left: 10px;
    padding-right: 10px;
    height: 52px;
    line-height: 52px;
}
.qyRight{
    width: 200px;
    border-top: 1px solid #EEEEEE;
    border-right: 1px solid #EEEEEE;
    padding-left: 10px;
    padding-right: 10px;
    height: 52px;
    line-height: 52px;
}
</style>

<style lang="scss">
.createPlayStep {
  .el-step.is-horizontal .el-step__line {
    height: 1px;
  }
  .el-step__head.is-success {
    color: #7b61ff;
    border-color: #7b61ff;
    .el-step__line {
      background-color: #7b61ff;
    }
  }
  .el-step__head.is-process {
    color: #7b61ff;
    border-color: #7b61ff;
  }
  .el-step__title.is-process {
    color: #7b61ff;
  }
  .el-step__title.is-success {
    color: #7b61ff;
  }
  // .textarea {
  //   .el-textarea__inner {
  //     min-height: 80px !important;
  //   }
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
